export const ESTIMATE_ACCEPT_KEY = process.env.GATSBY_ESTIMATE_ACCEPT_KEY || "";
